
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import RevcellaDetailSection from '../home/components/RevcellaDetailSection';
import ReservationSection from '../home/components/ReservationSection';

const RevcellaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-light-gold/30 to-white">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle, #C9A961 1px, transparent 1px)',
              backgroundSize: '50px 50px'
            }}></div>
          </div>

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-20 text-center">
            <div className="inline-block bg-gold/10 border border-gold/30 rounded-full px-6 py-2 mb-6">
              <p className="text-gold text-sm font-semibold tracking-widest">REVCELLA</p>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-dark-gray mb-6 leading-tight">
              エステティックプラズマで<br />
              <span className="text-gold">肌の再生力を高める</span>
            </h1>
            
            <p className="text-lg md:text-xl text-dark-gray/80 mb-8 leading-relaxed max-w-3xl mx-auto">
              第4の状態「プラズマ」の力で、<br className="hidden md:block" />
              美容成分を肌の深部まで浸透させる次世代フェイシャル
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  const element = document.querySelector('#reservation');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="w-full sm:w-auto bg-gold text-white px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                Revcellaを予約する
              </button>
              <button
                onClick={() => window.open('https://line.me/R/ti/p/@luciall', '_blank')}
                className="w-full sm:w-auto bg-white text-gold border-2 border-gold px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                LINEで相談する
              </button>
            </div>
          </div>
        </section>

        <RevcellaDetailSection />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
};

export default RevcellaPage;
